export const API_URL = "https://sicarsapi.rentsolution.net/api"
//export const API_URL = 'http://localhost:8001/api'